export default function($) {
  let homePostsSwiper = document.querySelector('.js-home-posts-slider');
  let homeProductsSwiper = document.querySelector('.js-home-products-slider');
  let upsellsProductsSwiper = document.querySelector('.js-upsells-products-slider');

  const homeBannerSwiper = new Swiper('.js-home-banner-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 600,
    pagination: {
      el: "#home-banner-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-home-banner-swiper',
      prevEl: '.swiper-button-prev-home-banner-swiper',
    }
  });

  const homeProductsSwiperParams = {
    slidesPerView: 1.5,
    spaceBetween: 32,
    pagination: {
      el: "#home-products-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-home-products-swiper',
      prevEl: '.swiper-button-prev-home-products-swiper',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
        navigation: {
          enabled: false,
        }
      },
    },
    on: {
      destroy: function() {
        $('#home-products-swiper-pagination').hide();
        $('#swiper-button-nav-home-products-swiper').hide();
      },
      init: function() {
        $('#home-products-swiper-pagination').show();
        $('#swiper-button-nav-home-products-swiper').show();
      },
    },
  };

  const homePostsSwiperParams = {
    slidesPerView: 1.2,
    spaceBetween: 32,
    pagination: {
      el: "#home-posts-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-home-posts-swiper',
      prevEl: '.swiper-button-prev-home-posts-swiper',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
        navigation: {
          enabled: false,
        }
      },
    },
    on: {
      destroy: function() {
        $('#home-posts-swiper-pagination').hide();
        $('#swiper-button-nav-home-posts-swiper').hide();
      },
      init: function() {
        $('#home-posts-swiper-pagination').show();
        $('#swiper-button-nav-home-posts-swiper').show();
      },
    },
  };

  const upsellsProductsSwiperParams = {
    slidesPerView: 1.5,
    spaceBetween: 32,
    pagination: {
      el: "#upsells-products-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-upsells-products-swiper',
      prevEl: '.swiper-button-prev-upsells-products-swiper',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
        navigation: {
          enabled: false,
        }
      },
    },
    on: {
      destroy: function() {
        $('#upsells-products-swiper-pagination').hide();
        $('#swiper-button-nav-upsells-products-swiper').hide();
      },
      init: function() {
        $('#upsells-products-swiper-pagination').show();
        $('#swiper-button-nav-upsells-products-swiper').show();
      },
    },
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( window.innerWidth < 1024 ) {
      if( $('.js-home-posts-slider').length > 0 && !homePostsSwiper.initialized ) {
        homePostsSwiper = new Swiper('.js-home-posts-slider', homePostsSwiperParams);
      };
      if( $('.js-home-products-slider').length > 0 && !homeProductsSwiper.initialized ) {
        homeProductsSwiper = new Swiper('.js-home-products-slider', homeProductsSwiperParams);
      };
      if( $('.js-upsells-products-slider').length > 0 && !upsellsProductsSwiper.initialized ) {
        upsellsProductsSwiper = new Swiper('.js-upsells-products-slider', upsellsProductsSwiperParams);
      };
    }

    else {
      if( $('.js-home-posts-slider').length > 0 && homePostsSwiper.initialized ) {
        homePostsSwiper.destroy(false,true);
        $('.js-home-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#home-posts-swiper-pagination').hide();
        $('#swiper-button-nav-home-posts-swiper').hide();
      };
      if( $('.js-home-products-slider').length > 0 && homeProductsSwiper.initialized ) {
        homeProductsSwiper.destroy(false,true);
        $('.js-home-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#home-products-swiper-pagination').hide();
        $('#swiper-button-nav-home-products-swiper').hide();
      };
      if( $('.js-upsells-products-slider').length > 0 && upsellsProductsSwiper.initialized ) {
        upsellsProductsSwiper.destroy(false,true);
        $('.js-upsells-products-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#upsells-products-swiper-pagination').hide();
        $('#swiper-button-nav-upsells-products-swiper').hide();
      };
    }
  }

  function getProductGalleryConfig() {
    const isVertical = window.innerWidth >= 1280;
    return {
      direction: isVertical ? 'vertical' : 'horizontal',
      slidesPerView: 4,
      loop: false,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.swiper-button-next-products-gallery-swiper',
        prevEl: '.swiper-button-prev-products-gallery-swiper',
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 24 },
        768: { slidesPerView: 2, spaceBetween: 24 },
        1024: { slidesPerView: 3, spaceBetween: 24 },
        1280: { slidesPerView: 2, spaceBetween: 24 },
        1536: { slidesPerView: 3, spaceBetween: 24 },
      },
    };
  }

  let productGallerySwiper = new Swiper('.js-product-gallery-swiper', getProductGalleryConfig());

  $(window).on('resize.productGallery', function() {
    const shouldBeVertical = window.innerWidth >= 1280;
    const isVertical = productGallerySwiper.params.direction === 'vertical';
    if (shouldBeVertical !== isVertical) {
      productGallerySwiper.destroy(true, true);
      productGallerySwiper = new Swiper('.js-product-gallery-swiper', getProductGalleryConfig());
    }
  });

  $('.js-product-thumb').on('click', function() {
    var srcMediumLarge = $(this).data( 'mediumlarge' ),
        srcXXLarge = $(this).data( 'xxlarge' ),
        srcset = $(this).data( 'srcset' ),
        alt = $(this).attr( 'alt' ),
        title = $(this).attr( 'title' );

    $(this).parents('.js-product-gallery').find('.js-product-image').attr( 'src', srcMediumLarge );
    $(this).parents('.js-product-gallery').find('.js-product-image').attr( 'srcset', srcset );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'href', srcXXLarge );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'data-title', title );
    $(this).parents('.js-product-gallery').find('.js-product-zoom').attr( 'data-alt', alt );
  })
}
